export default __webpack_public_path__ + "static/media/PasserCommande.869fef40.png";